var _path, _path2, _g, _circle, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEmptyContacts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 67,
    viewBox: "0 0 66 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 67C43.464 67 56 54.464 56 39C56 23.536 43.464 11 28 11C12.536 11 0 23.536 0 39C0 54.464 12.536 67 28 67Z",
    fill: "#EDF5F1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12140_23022",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 15,
    width: 48,
    height: 48
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 63C41.2548 63 52 52.2548 52 39C52 25.7452 41.2548 15 28 15C14.7452 15 4 25.7452 4 39C4 52.2548 14.7452 63 28 63Z",
    fill: "#EDF5F1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12140_23022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5 38C32.6421 38 36 34.6421 36 30.5C36 26.3579 32.6421 23 28.5 23C24.3579 23 21 26.3579 21 30.5C21 34.6421 24.3579 38 28.5 38Z",
    fill: "#CEDFD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 73C37.3888 73 45 65.3888 45 56C45 46.6112 37.3888 39 28 39C18.6112 39 11 46.6112 11 56C11 65.3888 18.6112 73 28 73Z",
    fill: "#CEDFD5"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 13.5,
    r: 13.5,
    fill: "#2974B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0532 13.0265C58.0532 12.4713 57.6031 12.0212 57.0479 12.0212L54.0322 12.0212L54.0322 9.00532C54.0322 8.4501 53.5821 8 53.0269 8C52.4717 8 52.0216 8.4501 52.0216 9.00532L52.0216 12.0212L49.0053 12.0212C48.4501 12.0212 48 12.4713 48 13.0265C48 13.5817 48.4501 14.0318 49.0053 14.0318L52.0216 14.0318L52.0216 17.0479C52.0216 17.6031 52.4717 18.0532 53.0269 18.0532C53.5821 18.0532 54.0322 17.6031 54.0322 17.0479L54.0322 14.0318L57.0479 14.0318C57.6031 14.0318 58.0532 13.5817 58.0532 13.0265Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyContacts);
export default __webpack_public_path__ + "static/media/icon_empty_contacts.96f91980bb4e4c7157125aba46c62e1f.svg";
export { ForwardRef as ReactComponent };